import { Data2, newId } from '../../../features/data-types'
import { useSystemStateHooks } from '../../system'
import { CustomerType, ProductYield } from '../state/types'

export const useCustomerTypeBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildCustomerType = (data: Data2) => {
        const {
            id = newId(),
            name,
            yield: _yield,
            productYields,
            archived,
            baseCustomerTypeId
        } = data

        const customerType: CustomerType = {
            companyId: companyId!,
            id: id! as string,
            name: name! as string,
            yield: _yield! as number,
            productYields: (productYields || []) as ProductYield[],
            archived: !!archived,
            baseCustomerTypeId: baseCustomerTypeId as string | undefined
        }

        return customerType
    }

    return {
        buildCustomerType
    }
}
